import React, { useState, useEffect } from 'react';
import { colors } from '../theme/tokens';

const ImageViewer = ({ partCode, onClose }) => {
  const [imageExists, setImageExists] = useState(true);
  const [loading, setLoading] = useState(true);

  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
  const imageUrl = `${API_URL}/api/images/${partCode}`;
  const storeUrl = `https://parmegastore.com/search?type=product&q=${partCode}`;

  useEffect(() => {
    // Check if image exists
    fetch(imageUrl)
      .then(res => {
        if (!res.ok) {
          setImageExists(false);
        }
        setLoading(false);
      })
      .catch(() => {
        setImageExists(false);
        setLoading(false);
      });
  }, [imageUrl]);

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const openStore = () => {
    window.open(storeUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div style={styles.backdrop} onClick={handleBackdropClick}>
      <div style={styles.modal}>
        {/* Close button */}
        <button style={styles.closeBtn} onClick={onClose}>
          ✕
        </button>

        {/* Part Code Header */}
        <div style={styles.header}>
          <h2 style={styles.partCode}>{partCode}</h2>
        </div>

        {/* Image Container */}
        <div style={styles.imageContainer}>
          {loading ? (
            <div style={styles.loading}>Loading image...</div>
          ) : imageExists ? (
            <img 
              src={imageUrl} 
              alt={partCode} 
              style={styles.image}
              onError={() => setImageExists(false)}
            />
          ) : (
            <div style={styles.noImage}>
              <div style={styles.noImageIcon}>📷</div>
              <p>No image available for this part</p>
            </div>
          )}
        </div>

        {/* View on Store Button */}
        <button style={styles.storeBtn} onClick={openStore}>
          🛒 View on Par Mega Store
        </button>
      </div>
    </div>
  );
};

const styles = {
  backdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: colors.overlay,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10000,
    padding: '20px',
    animation: 'fadeIn 0.2s ease-in'
  },
  modal: {
    backgroundColor: colors.surfaceSolid,
    color: colors.text,
    borderRadius: '15px',
    maxWidth: '800px',
    width: '100%',
    maxHeight: '90vh',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)',
    position: 'relative',
    animation: 'slideUp 0.3s ease-out',
    border: `1px solid ${colors.border}`
  },
  closeBtn: {
    position: 'absolute',
    top: '15px',
    right: '15px',
    background: colors.red,
    color: 'white',
    border: 'none',
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    fontSize: '24px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10,
    transition: 'transform 0.2s, background 0.2s',
    fontWeight: 'bold',
    lineHeight: '1'
  },
  header: {
    padding: '25px 25px 15px 25px',
    borderBottom: '2px solid #2fb65c'
  },
  partCode: {
    margin: 0,
    color: '#2fb65c',
    fontSize: '28px',
    fontWeight: 'bold',
    fontFamily: 'monospace',
    textAlign: 'center'
  },
  imageContainer: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '30px',
    overflow: 'auto',
    minHeight: '300px'
  },
  image: {
    maxWidth: '100%',
    maxHeight: '500px',
    objectFit: 'contain',
    borderRadius: '8px',
    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)'
  },
  loading: {
    fontSize: '18px',
    color: colors.textMuted,
    textAlign: 'center'
  },
  noImage: {
    textAlign: 'center',
    color: colors.textMuted
  },
  noImageIcon: {
    fontSize: '64px',
    marginBottom: '15px'
  },
  storeBtn: {
    margin: '0 25px 25px 25px',
    padding: '15px 30px',
    background: '#2fb65c',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'transform 0.2s, background 0.2s',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px'
  }
};

export default ImageViewer;
